// Mock data for CBTU Region III website

export const ASSETS = {
  // Local assets served from the same origin - no CORS / mobile Safari blocking issues
  roundLogo: '/images/round-logo.png',
  regionLogo: '/images/region-logo.png',
  conferenceBanner: '/images/conference-banner.png',
  saveTheDate: '/images/save-the-date.png',
  sponsorshipSheet: '/images/sponsorship-sheet.png',
  registrationForm: '/images/registration-form.png',
  morehousePhoto: '/images/morehouse.webp',
  zellePayment: '/images/zelle-payment.png',
  agendaPdf: '/docs/cbtu-region-iii-2026-agenda-v3.pdf',
  parkingFlyer: '/images/complimentary-parking-flyer.jpg',
  digitalJournalCover: '/images/digital-journal-cover.jpg',
  journalReleaseAt: '2026-10-31T18:00:00-04:00',
  souvenirJournalCover: '/images/souvenir-journal-2026-cover.jpg',
  doubletreeHotel: '/images/doubletree-jacksonville.png',
};

export const ZELLE = {
  name: 'CBTU Region 3',
  email: 'cbturegioniii@gmail.com',
  image: '/images/zelle-payment.png',
};

export const LATE_REGISTRATION = {
  active: false,
  fee: 50,
  onsiteDate: 'Friday, October 30, 2026',
  payLink: '',
};

export const REGISTRATION_FEES = [
  { category: 'Member Registration', price: 150, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-c7e5bb96cf5043f3b042157639bb8bd24151ead4f6544c078b56e22b711468b3352a181b38ec44c4a83ee56321eb435b-0?locale=EN_US&cta=paylinkbuybutton' },
  { category: 'Guest Registration', price: 150, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-c7e5bb96cf5043f3b042157639bb8bd24151ead4f6544c078b56e22b711468b3352a181b38ec44c4a83ee56321eb435b-0?locale=EN_US&cta=paylinkbuybutton' },
  { category: 'Retiree Registration', price: 100, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-117bf7440378419688d778bd3ae782ff8493df39054b48899ba8d023647707aa8416eca82c2942c695c17c438bac5f7b-1?locale=EN_US&cta=paylinkbuybutton' },
  { category: 'Youth Registration', price: 100, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-5cbc3ecfe1f2468d85b8fe65b273d0d571396bbd8596487d8f331ef28d81df694a321718890a4286b43192ab06534b48-0?locale=EN_US&cta=paylinkbuybutton' },
];

export const PAYMENT_METHODS = ['Cash', 'Check', 'Money Order', "Cashier's Check", 'Zelle', 'Cash App', 'Other'];

export const BANQUET_TICKET_PRICE = 125;

export const SPONSORSHIP_TIERS = [
  { tier: 'Presenting Sponsor', price: 10000 },
  { tier: 'Platinum Sponsor', price: 5000, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-ddc67f293ea441ce9f9b8deae82acdfa6d41e30883bc457386b975b7f0271e42d53157f327bf42f283e7e72ef414893d-0?locale=EN_US&cta=paylinkbuybutton' },
  { tier: 'Gold Sponsor', price: 3000, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-a1dc82f16d4945c78ee74c5b4cb61e87e68df1ff886445b4bdb29854a49e2ddd34203abb7fe04fe6a171e3bd51872884-1?locale=EN_US&cta=paylinkbuybutton' },
  { tier: 'Silver Sponsor', price: 2000, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-38314495764d4300961c4690085024ebfca8c597637743088c6d17c051e923354ba4eb01ce774253ba5419ff342ffc64-1?locale=EN_US&cta=paylinkbuybutton' },
  { tier: 'Bronze Sponsor', price: 1250 },
];

export const JOURNAL_AD_SIZES = [
  { size: 'Full Page Ad', price: 300 },
  { size: 'Half Page Ad', price: 175 },
  { size: 'Quarter Page Ad', price: 100 },
  { size: 'Business Card Ad', price: 50 },
];

export const REGISTRATION_MAIL = {
  org: 'CBTU Region III',
  poBox: 'P.O. Box 8303',
  cityStateZip: 'Fort Lauderdale, FL 33310',
  earlyDeadline: 'September 1, 2026',
  paymentMethods: ['Cash', 'Money Order', "Cashier's Check", 'Zelle', 'Cash App', 'Other'],
};

export const CHAPTERS = [
  {
    slug: 'south-florida',
    name: 'South Florida',
    state: 'Florida',
    city: 'Miami, FL',
    founded: '1985',
    president: 'Sheryl Lemon',
    presidentTitle: 'Chapter President',
    union: '',
    email: 'Sheryl.lemon@yahoo.com',
    phone: '(305) 206-1328',
    meeting: '',
    venue: 'Miami-Dade County, FL',
    summary: 'Serving Miami-Dade and the Florida Keys, the South Florida chapter advocates for Black union members across hospitality, transit, healthcare, and public service.',
    initiatives: ['Annual MLK Labor Breakfast', 'Voter registration drive in Liberty City', 'Youth apprenticeship pipeline', 'Hurricane relief mutual-aid network'],
    socials: {},
  },
  {
    slug: 'broward-county',
    name: 'Broward County',
    state: 'Florida',
    city: 'Fort Lauderdale, FL',
    founded: '1992',
    president: 'Ron Nielly',
    presidentTitle: 'Chapter President',
    union: 'AFSCME',
    email: 'ronald.nielly@gmail.com',
    phone: '(954) 445-2796',
    meeting: '',
    venue: 'Broward County, FL',
    summary: 'The Broward County chapter unites trade unionists from Fort Lauderdale, Pompano Beach, and Hollywood in the fight for economic and social justice.',
    representedUnions: [
      { name: 'ILA', description: "International Longshoremen's Association \u2014 dock and port workers." },
      { name: 'AFSCME', description: 'American Federation of State, County and Municipal Employees.' },
      { name: 'BTU', description: 'Broward Teachers Union \u2014 K-12 educators and support staff in Broward County.' },
      { name: 'IUPAT', description: 'International Union of Painters and Allied Trades \u2014 represents construction workers.' },
      { name: 'UTD', description: 'United Teachers of Dade \u2014 K-12 educators across Miami-Dade County.' },
      { name: 'AFGE', description: 'American Federation of Government Employees.' },
      { name: 'APWU', description: 'American Postal Workers Union.' },
    ],
    featuredProgram: {
      title: 'Trade Mentorship Program',
      partners: ['ILA', 'IBEW', 'IUPAT'],
      description: 'The Broward County chapter is working together with local unions \u2014 ILA, IBEW, and IUPAT \u2014 to provide trade-skill services and mentorship to at-risk youth in Broward and Miami-Dade County.',
    },
    initiatives: ['Trade Mentorship Program with ILA, IBEW & IUPAT \u2014 serving at-risk youth in Broward & Miami-Dade', 'Black History Month Labor Forum', 'Teacher solidarity rallies with BTU', 'Community fridges & food pantry partnerships', 'Get-Out-The-Vote canvassing'],
    socials: { facebook: 'https://www.facebook.com/profile.php?id=100071258838237' },
  },
  {
    slug: 'central-florida',
    name: 'Central Florida',
    state: 'Florida',
    city: 'Orlando, FL',
    founded: '1989',
    president: 'Sonya Stalnaker',
    presidentTitle: 'Chapter President',
    union: 'IUPAT',
    email: 'smstalnaker2@gmail.com',
    phone: '(407) 405-5244',
    meeting: 'To Be Announced',
    venue: 'Central Florida \u00b7 I-4 Corridor',
    summary: 'Anchored in Orlando, the Central Florida chapter represents theme-park workers, educators, and public employees across the I-4 corridor.',
    representedUnions: [
      { name: 'IUPAT', description: 'International Union of Painters and Allied Trades \u2014 represents construction workers.' },
      { name: 'AFGE', description: 'American Federation of Government Employees.' },
    ],
    initiatives: ['Disney/UNITE HERE contract solidarity', 'College scholarship program', 'Pre-K literacy partnership', 'Annual Juneteenth Labor Day picnic'],
    socials: {},
  },
  {
    slug: 'jacksonville',
    name: 'Jacksonville',
    state: 'Florida',
    city: 'Jacksonville, FL',
    founded: '1981',
    president: 'Eric Biggins',
    presidentTitle: 'Chapter President \u00b7 Region III Host Chapter',
    union: '',
    email: 'Ewbiggins@yahoo.com',
    phone: '(904) 537-3477',
    meeting: '',
    venue: 'Jacksonville, FL \u00b7 First Coast',
    summary: 'Home chapter of the 2026 Region III Conference, Jacksonville organizes longshore, transit, postal, and municipal workers across the First Coast.',
    initiatives: ['Hosting CBTU Region III Conference 2026', 'Port workers solidarity committee', 'Northside voter education', 'Historic Eastside neighborhood revitalization'],
    socials: { instagram: 'https://instagram.com/cbtu_jax' },
    photos: [
      {
        src: '/images/jacksonville/community-canvass-2026.jpg',
        caption: 'Community Canvass · Boots on the Ground',
        instagram: 'https://instagram.com/cbtu_jax',
        handle: '@CBTU_jax',
      },
      {
        src: '/images/jacksonville/voter-registration-ila1408.jpg',
        caption: 'Voter Registration Drive at ILA Local 1408',
        instagram: 'https://instagram.com/cbtu_jax',
        handle: '@CBTU_jax',
      },
    ],
  },
  {
    slug: 'savannah',
    name: 'Savannah',
    state: 'Georgia',
    city: 'Savannah, GA',
    founded: '1994',
    president: 'Ronald Montague, Sr.',
    presidentTitle: 'Chapter President',
    union: 'ILA',
    email: 'rmontague@ila1414.com',
    phone: '(912) 272-3005',
    meeting: '',
    venue: 'Savannah, GA \u00b7 Coastal Empire',
    summary: 'The Savannah chapter represents port, paper-mill, and service workers across the Coastal Empire and Lowcountry of Georgia.',
    initiatives: ['Port of Savannah workers council', 'HBCU labor history lecture series', 'Coastal community organizing', 'Reentry job training partnerships'],
    socials: {},
  },
  {
    slug: 'charleston',
    name: 'Charleston',
    state: 'South Carolina',
    city: 'Charleston, SC',
    founded: '1990',
    president: 'Noel Crosby, Jr.',
    presidentTitle: 'Chapter President',
    union: '',
    email: 'noelcrosby@hotmail.com',
    phone: '(843) 817-8230',
    meeting: '',
    venue: 'Charleston, SC \u00b7 Lowcountry',
    summary: 'Carrying the legacy of the Charleston 5, this chapter is a stronghold of Black labor power in the Lowcountry and across the Carolinas.',
    initiatives: ['Charleston 5 commemoration', 'Right-to-work fightback campaign', 'Port community benefit agreements', 'Voting rights coalition with SC NAACP'],
    socials: { facebook: 'https://www.facebook.com/share/1DHWuiKQWH/' },
  },
  {
    slug: 'metro-atlanta',
    name: 'Metro Atlanta',
    state: 'Georgia',
    city: 'Atlanta, GA',
    founded: '1975',
    president: 'Eric Richardson',
    presidentTitle: 'Chapter President',
    union: '',
    email: 'Elr912@gmail.com',
    phone: '(404) 216-5248',
    meeting: '',
    venue: 'Metro Atlanta, GA',
    summary: 'The flagship Metro Atlanta chapter spans Fulton, DeKalb, Cobb, Gwinnett, and Clayton counties \u2014 a powerhouse for Southern labor and civil rights organizing.',
    initiatives: ['Annual A. Philip Randolph Lecture', 'MARTA workers solidarity', 'Atlanta Public Schools teacher advocacy', 'Voting Rights bus to the Capitol'],
    socials: {},
  },
];

const ALL_NEWS = [
  {
    id: 'conference-activities-2026',
    title: 'Conference Activities: Halloween Party & NW Classic Parade GOTV',
    date: 'Oct 29, 2026',
    excerpt: 'Friday, Oct 30, 5–10 PM: Halloween Meet & Greet Party (Scare · Slay · Win) in the Amelia Room / Hotel Pool Area. Cash bar and light bites; conference badge required. Saturday, Oct 31, 10 AM–Noon: Get Out the Vote at the NW Classic Parade & Early Voting Drive. Depart the hotel at 9:30 AM and meet at Café Resistance Bookstore & Coffee Shop, 5007 Soutel Dr, Jacksonville, FL (Voters Hub, across from The Legends Center).',
    tag: 'Conference',
    img: '/images/flyer-halloween-meet-greet.jpg',
    imgTop: true,
    link: '/conference',
    linkLabel: 'VIEW CONFERENCE →',
    accent: 'gold',
  },
  {
    id: 'onsite-registration-2026',
    title: 'Pay On Site: $200 Registration & Banquet Tickets Still Available',
    date: 'Oct 29, 2026',
    excerpt: 'Still need to register? Conference registration can now be paid on site for $200.00 at the registration desk in the Foyer of the DoubleTree Jacksonville Riverfront. Banquet tickets for the Champions of Labor Honoree Banquet are still available and can be purchased on site at registration.',
    tag: 'Conference',
    img: '/images/digital-journal-cover.jpg',
    imgTop: true,
    link: '/conference#register',
    linkLabel: 'REGISTRATION DETAILS →',
    hideAfter: '2026-11-01T12:00:00-05:00',
    accent: 'gold',
  },
  {
    id: 'thank-you-2026',
    showAfter: '2026-11-01T12:00:00-05:00',
    title: 'Thank You for Joining Us in Jacksonville!',
    date: 'Nov 1, 2026',
    excerpt: 'Thank you to every member, guest, honoree, sponsor and volunteer who made the CBTU Region III 2026 Regional Conference a success. Photos from the conference will be available and posted on the cbturegion3.org website soon. IF YOU DID NOT EARLY VOTE, PLEASE MAKE YOUR PLAN TO VOTE ON TUESDAY, NOVEMBER 3! Take a friend, all the registered voters in your house, and the people you know who didn\'t early vote to the polls. Get the word out! Flip through the Digital Ad Journal to relive the weekend and thank our sponsors.',
    tag: 'Conference',
    img: '/images/digital-journal-cover.jpg',
    imgTop: true,
    link: '/digital-journal',
    linkLabel: 'READ THE JOURNAL →',
    accent: 'gold',
  },
  {
    id: 'conference-meeting-rooms-2026',
    title: 'Conference Week: Agenda & Meeting Rooms',
    date: 'Oct 29, 2026',
    excerpt: 'The Region III Conference is underway at the DoubleTree Jacksonville Riverfront. Friday sessions are in Duval CDE (breakfast & lunch provided), Saturday events are in Duval A with the Trade Fair in the St. Johns Foyer (lunch not provided), and Sunday service is in Duval BCDE (breakfast provided). See the full agenda, rooms and printable meeting room flyers.',
    tag: 'Conference',
    img: '/images/sign-friday-oct-30.jpg',
    imgTop: true,
    link: '/conference#agenda',
    linkLabel: 'VIEW AGENDA & ROOMS →',
    accent: 'gold',
  },
  {
    id: 'digital-ad-journal-2026',
    title: 'Digital Ad Journal Opens Saturday, Oct 31 at 6:00 PM',
    date: 'Oct 29, 2026',
    excerpt: 'The 26-page 2026 Digital Ad Journal, honoring our Champions of Labor and thanking our sponsors and advertisers, opens online Saturday, October 31 at 6:00 PM ET. Flip through every page right on the website.',
    tag: 'Conference',
    img: '/images/digital-journal-cover.jpg',
    imgTop: true,
    link: '/digital-journal',
    linkLabel: 'GO TO THE JOURNAL →',
    accent: 'gold',
  },
  {
    id: 'complimentary-parking-2026',
    title: 'Complimentary Conference Parking: Use Code CBTU28',
    date: 'Oct 23, 2026',
    excerpt: 'Driving to the conference? Follow the parking flyer to get complimentary self-parking at the DoubleTree Jacksonville Riverfront. Scan a garage QR code before you leave for the first time, enter your name, phone, tag #, and dates, then enter validation code CBTU28, click Apply and Start Parking. The garage reads license plates, so if no code is entered a citation is mailed. No smartphone? A parking attendant at the hotel entrance can help.',
    tag: 'Conference',
    img: '/images/complimentary-parking-flyer.jpg',
    imgTop: true,
    link: '/conference#parking',
    accent: 'gold',
  },
  {
    id: 'no-kings-jax-2026-10-17',
    title: 'NO KINGS — Jacksonville Early Voting Caravan & Community Action',
    date: 'Oct 17, 2026',
    excerpt: 'CBTU Jacksonville joins the North Florida Central Labor Council, Northside Coalition, Harriet Tubman Freedom Fighters, and Up N Smoke Catering for a day of early voting sign-waves, caravans, and free food. Starts 11:00 AM at SOUTEL US-1 (Popeyes) and ends at the Court House. Sign up for rides to the polls!',
    tag: 'Jacksonville',
    img: '/images/no-kings-jax-oct17.png',
    accent: 'gold',
    chapterSlug: 'jacksonville',
    instagram: 'https://instagram.com/cbtu_jax',
    socialHandle: '@CBTU_jax',
  },
  {
    id: 0,
    title: '2026 CBTU Executive Board Meeting — Chicago, IL',
    date: 'Sep 10 – 11, 2026',
    excerpt: 'CBTU International will host its 2026 Executive Board Meeting at the Hilton Chicago (720 S. Michigan Avenue). Board members will focus on mobilizing, turning out and protecting voters ahead of the 2026 Midterm Election. Executive Board Members Only.',
    tag: 'National',
    img: '/images/exec-board-2026.png',
    accent: 'gold',
  },
  {
    id: 1,
    title: 'Save the Date: CBTU Region III Conference — Jacksonville, FL',
    date: 'Oct 29 – Nov 1, 2026',
    excerpt: 'Join labor leaders from Florida, Georgia, North Carolina, and South Carolina for the 2026 Region III Conference & Champions of Labor Awards Banquet at the DoubleTree by Hilton Jacksonville Riverfront.',
    tag: 'Conference',
    img: '/images/save-the-date.png',
    accent: 'gold',
  },
  {
    id: 2,
    title: 'Region III Stands With Port Workers on the East Coast',
    date: 'Mar 14, 2026',
    excerpt: 'CBTU Region III chapters in Charleston, Savannah, and Jacksonville issue a joint statement of solidarity with ILA members fighting for fair contracts and protections against automation.',
    tag: 'Solidarity',
    img: null,
    accent: 'green',
  },
  {
    id: 3,
    title: 'Metro Atlanta Hosts A. Philip Randolph Lecture Series',
    date: 'Feb 22, 2026',
    excerpt: 'Hundreds gathered at Morehouse College for the 11th annual A. Philip Randolph lecture, keynoted by CBTU International President Rev. Terrence L. Melvin.',
    tag: 'Events',
    img: '/images/morehouse.webp',
    accent: 'gold',
  },
  {
    id: 4,
    title: 'Voter Registration Wave: 4,200+ New Voters Across Region III',
    date: 'Jan 18, 2026',
    excerpt: 'A coordinated GOTV effort across all seven Region III chapters registered more than 4,200 new voters during the MLK Day weekend canvass.',
    tag: 'Civic Engagement',
    img: null,
    accent: 'navy',
  },
  {
    id: 5,
    title: 'Champions of Labor Awards Banquet — Nominations Open',
    date: 'Jan 06, 2026',
    excerpt: 'Nominate a rank-and-file leader, an elected official, or a community partner for the 2026 Champions of Labor Awards. Deadline August 15, 2026.',
    tag: 'Awards',
    img: null,
    accent: 'gold',
  },
  {
    id: 6,
    title: 'South Florida Chapter Wraps MLK Labor Breakfast',
    date: 'Jan 15, 2026',
    excerpt: 'More than 600 union members and community leaders gathered in Miami for the chapter\'s annual MLK Labor Breakfast, raising over $40,000 for scholarships.',
    tag: 'Chapters',
    img: null,
    accent: 'green',
  },
];

export const NEWS = ALL_NEWS.filter((n) => (!n.showAfter || Date.now() >= new Date(n.showAfter).getTime()) && (!n.hideAfter || Date.now() < new Date(n.hideAfter).getTime()));

export const REGION_LEADERSHIP = [
  { name: 'Rev. Terrence L. Melvin', role: 'CBTU International President', union: 'AFSCME', city: 'Washington, DC' },
  { name: 'Mike D. Payne', role: 'Region III Representative', union: 'ILA', city: 'Region III' },
];

export const CONFERENCE = {
  title: 'CBTU Region III Regional Conference & Champions of Labor Awards Banquet',
  theme: 'Protecting Our Future Through the Power of the Vote and the Strength of Organized Labor',
  dates: 'October 29, 2026 – November 1, 2026',
  venue: 'DoubleTree by Hilton Jacksonville Riverfront',
  address: '1201 Riverplace Blvd, Jacksonville, FL 32207',
  ticketPrice: 125,
  sponsorships: [
    { tier: 'Presenting Sponsor', price: 10000, color: 'gold', perks: ['Premium VIP Table for 10', 'Premier Recognition as Presenting Sponsor', 'Full Page Premium Ad (Inside Front or Back Cover)', 'Logo Featured on All Event Materials', 'Recognition During Program & Awards Presentation', 'Recognition on CBTU Region III Website & Social Media', 'Opportunity to Provide Promotional Materials'] },
    { tier: 'Platinum Sponsor', price: 5000, color: 'platinum', perks: ['VIP Table for 10', 'Full Page Color Ad', 'Recognition on CBTU Region III Website', 'Podium Recognition During Banquet', 'Logo Displayed During Event'], payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-0797705787074858ae6e8d17177d5e6ce4d1155e7c6847258f62d3201cf385beae27afd66d4743739a6c43543d86e456-0?locale=EN_US&cta=paylinkbuybutton' },
    { tier: 'Gold Sponsor', price: 3000, color: 'gold', perks: ['Reserved Table for 8', 'Full Page Ad', 'Website Recognition', 'Recognition During Banquet Program'], payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-ddc67f293ea441ce9f9b8deae82acdfa6d41e30883bc457386b975b7f0271e42d53157f327bf42f283e7e72ef414893d-0?locale=EN_US&cta=paylinkbuybutton' },
    { tier: 'Silver Sponsor', price: 2000, color: 'silver', perks: ['Reserved Table for 5', 'Half Page Ad', 'Website Recognition'], payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-a1dc82f16d4945c78ee74c5b4cb61e87e68df1ff886445b4bdb29854a49e2ddd34203abb7fe04fe6a171e3bd51872884-1?locale=EN_US&cta=paylinkbuybutton' },
    { tier: 'Bronze Sponsor', price: 1250, color: 'bronze', perks: ['Reserved Table for 4', 'Quarter Page Ad', 'Name Recognition on Website & Event Program'], payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-38314495764d4300961c4690085024ebfca8c597637743088c6d17c051e923354ba4eb01ce774253ba5419ff342ffc64-1?locale=EN_US&cta=paylinkbuybutton' },
  ],
  journal: [
    { type: 'Full Page Ad', price: 300, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-a5145bec90cb4940a107ceb4f1426cf0c322e6cc6b254b228e4238dc37bae061f92b0663814743278e7d2f7b122735d8-0?locale=EN_US&cta=paylinkbuybutton' },
    { type: 'Half Page Ad', price: 175, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-d3e77800577246aa808f6936eebacaad82e17cfc8a6d4eec86dd2b6b5865b069dfe599fb14824ef9a8cc0af95355d66e-0?locale=EN_US&cta=paylinkbuybutton' },
    { type: 'Quarter Page Ad', price: 100, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-296b49a2a8ab42d2a1c8e14d4cde04f2e271d89ba5544a85af81ee6150c3e26e2d80ac0bd3c84316ac2a77dec61dc9a5-1?locale=EN_US&cta=paylinkbuybutton' },
    { type: 'Business Card Ad', price: 50, payLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-a759052cf2ea46159cad83aa00a94e5c877c6e8495f0468e8ee2b3ddc130ed95f1a516385e664c6eaf6cc1806600e613-1?locale=EN_US&cta=paylinkbuybutton' },
  ],
  banquetTicketPayLink: 'https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-8380ea91563b425b8a138fb68b382fdbffbb5aeb5784494ebd59a86cf529381dc7dd019b0a1c4ee389bed0ffe21173db-1?locale=EN_US&cta=paylinkbuybutton',
  daySigns: [
    { day: 'Sunday · Nov 1', label: 'Schedule & Room Locations', src: '/images/sign-sunday-nov-1.jpg?v=3' },
  ],
  recap: {
    active: true,
    unions: [
      'ILA Local 1408', 'ILA Local 1414', 'ILA Local 1416', 'ILA Local 1422', 'ILA Local 1526',
      'AFSCME Florida Council 79', 'AFSCME Florida 979 Organizing Committee', 'AFSCME Local 1328', 'AFSCME Local 1428', 'AFSCME Local 3293',
      'AFGE District 5', 'AFGE Local 696', 'AFGE Local 1985', 'AFGE Local 3627',
      'CWA Local 3204', 'CWA Local 3106 Retirees',
      'TWU Local 291', 'TWU Local 556',
      'IUPAT', 'IUPAT DC 77 Local 1961',
      'IBEW Local 177', 'IBEW Local 2358',
      'APWU Local 138', 'NEA',
      'South Florida AFL-CIO', 'North Florida Central Labor Council',
    ],
    sponsors: [
      { tier: 'Platinum', names: ['ILA Local 1526'] },
      { tier: 'Gold', names: ['AFSCME Florida Council 79', 'ILA Local 1414'] },
      { tier: 'Silver', names: ['South Florida AFL-CIO', 'Seafarers International Union (SIU)', 'ILA Local 1416', 'Harriett Tubman Freedom Fighters'] },
      { tier: 'Bronze', names: ['IUPAT Florida', 'TWU Local 291 Atlanta', 'CBTU Central Florida', 'CWA Atlanta', 'United Postal Workers of America, Washington DC', 'ILA Local 1422'] },
      { tier: 'Journal Advertisers', names: ['Teamsters Local 512', 'North Florida Central Labor Council', 'CBTU Delaware', 'Emanuel Pentecostal House of Worship'] },
    ],
  },
  featuredImage: { src: '/images/raffle-winner-2026.jpg', alt: 'Congratulations Keith, I.L.A. Local 1422 Charleston SC, CBTU Region III 50/50 Raffle Winner, $1,491' },
  activityFlyers: [],
  agenda: [
    {
      day: 'Thursday · Oct 29',
      date: '2026-10-29',
      items: [
        { time: '3:00 PM', title: 'CBTU Region III Executive Board Meeting', room: 'Seminole Conference Room · 2nd Floor' },
      ],
    },
    {
      day: 'Friday · Oct 30',
      date: '2026-10-30',
      items: [
        { time: '7:30 AM', title: 'Registration Opens', room: 'Foyer' },
        { time: '7:30 – 9:30 AM', title: 'Breakfast', room: 'Duval CDE', note: 'Breakfast and lunch provided by the conference.' },
        { time: '9:00 AM', title: 'General Session & Opening of the Conference', room: 'Duval CDE' },
        { time: '10:00 – 11:00 AM', title: 'Chapter Reports' },
        { time: '11:00 AM – 12:00 PM', title: 'Regional Elections & Swearing In of New Officers' },
        { time: '12:00 – 1:00 PM', title: 'Workshops', note: 'Workshops provided by the conference.' },
        { time: '1:00 – 2:00 PM', title: 'Lunch', room: 'Duval CDE' },
        { time: '2:00 – 4:00 PM', title: 'Workshops' },
        { time: '5:00 – 10:00 PM', title: 'Halloween Meet & Greet Party · Scare · Slay · Win', room: 'Amelia Room · 1st Floor / Hotel Pool Area', note: 'Cash Bar · Light bites will be served. Your conference badge is needed to attend.' },
      ],
    },
    {
      day: 'Saturday · Oct 31',
      date: '2026-10-31',
      items: [
        { time: '7:30 AM', title: 'Registration Reopens' },
        { time: '8:30 AM', title: 'General Session', room: 'Duval A' },
        { time: '9:30 AM – 12:00 PM', title: 'Phone Banking', room: 'Duval A', note: 'Partnership with APRI (GA & SOFL Chapters)' },
        { time: '9:30 AM', title: 'Depart Hotel for GOTV / NW Classic Parade', room: 'Café Resistance Bookstore & Coffee Shop · 5007 Soutel Dr, Jacksonville, FL' },
        { time: '10:00 AM – 12:00 PM', title: 'GOTV / NW Classic Parade & Early Voting Drive', room: 'Café Resistance Bookstore & Coffee Shop · 5007 Soutel Dr, Jacksonville, FL', note: 'Meet at Café Resistance Bookstore & Coffee Shop, 5007 Soutel Dr, Jacksonville, FL · Voters Hub across from The Legends Center' },
        { time: '12:00 – 1:00 PM', title: 'Lunch', note: 'Lunch is not provided by the conference.' },
        { time: '1:00 PM', title: 'Workshops', room: 'Duval A' },
        { time: '1:00 PM', title: 'Trade Fair', room: 'St. Johns Foyer' },
        { time: '6:00 PM', title: 'Cocktails with Candidates', room: 'Duval BCDE', note: 'Cash bar & light bites will be available.' },
        { time: '7:00 – 10:00 PM', title: 'Champions of Labor Honoree Banquet Dinner', note: 'Players Ball · Cash Bar · Keynote: Phyllis Lucy, daughter of CBTU Founder William "Bill" Lucy' },
      ],
    },
    {
      day: 'Sunday · Nov 1',
      date: '2026-11-01',
      items: [
        { time: '8:00 – 9:00 AM', title: 'Breakfast', note: 'Breakfast provided by the conference.' },
        { time: '9:00 AM', title: 'Church Service · Praise & Worship', room: 'Duval BCDE' },
        { time: '12:00 PM', title: 'Conference Concludes', note: 'Agenda subject to change.' },
      ],
    },
  ],
};

export const ABOUT = {
  mission: 'The Coalition of Black Trade Unionists consists of members from seventy-seven international and national unions with forty-two chapters across the country. CBTU seeks to fulfill the dream of those Black trade unionists, both living and deceased, who throughout this century have courageously and unremittingly struggled to build a national movement that would bring all our strengths and varied talents to bear in the unending effort to achieve economic, political and social justice for every American.',
  objectives: [
    'Improve economic development and employment opportunities for Black workers.',
    'Work within the framework of the trade union movement to provide a voice and vehicle for greater Black and minority participation.',
    'Increase union involvement in voter registration, voter education, and voter turnout projects.',
    'Organize the unorganized.',
    'Actively support civil rights and civic groups working to improve living and working conditions in the Black community.',
    'Increase effective political alliances between labor, churches, and the general community.',
  ],
  founders: ['Nelson "Jack" Edwards — UAW', 'Charles A. Hayes — UFCW', 'Cleveland Robinson — District 65 UAW', 'William "Bill" Lucy — AFSCME', 'William Simons — AFT'],
};
